import spartaTransportUtility from '@sparta.global.utilities/sparta-transport-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';

/**
 * Utility global-search-tracking-utility
 * @description Tracking utility for global-search-widget-modules
 * @copyright 2021-10-2
 * @file
 */

/**
 * The GlobalSearchTrackingUtility.
 * This utility is responsible for providing common methods for tracking.
 * @export
 * @class
 */
class GlobalSearchTrackingUtility {
  /**
   * Creates an instance of GlobalSearchTrackingUtility.
   * @param {object} params - used to initialize utility.
   * @memberof GlobalSearchTrackingUtility
   */
  constructor(params) {
    this.isAuth = params && params.isAuth;
    this.moduleInstance = params && params.moduleInstance;
    if (this.isAuth) {
      this.recordUserExperienceUrl = this.moduleInstance.jcrHelper.getUrl({
        key: 'recordUserExperienceAuth',
        secureAlways: true
      });
    } else {
      this.recordUserExperienceUrl = this.moduleInstance.jcrHelper.getUrl({
        key: 'recordUserExperienceUnAuth',
        secureAlways: true
      });
    }
    this.options = {
      headerResultsContainer: $('.global-nav-search'),
      stageResultsContainer: $('.spa-global-search-result--section'),
      delay: 500
    };
    this.data = null;
  }

  /**
   * Invoke record experience service
   * @param {object} request - request.
   * @returns void
   */
  invokeService(request) {
    this.ps = $.Deferred();
    try {
      if (request) {
        let data = null;
        if (request.type === 'selectedAnswer') {
          data = {
            cid: request.queryId,
            selectedAnswerId: request.answerId
          };
        } else {
          data = {
            cid: request.queryId,
            searchedAgain: true
          };
        }
        const transportObj = {
          cache: false,
          method: "POST",
          data: JSON.stringify(data),
          dataType: "json",
          contentType: "application/json",
          url: this.recordUserExperienceUrl,
          xhrFields: {
            withCredentials: true
          },
          success: $.proxy(this.successCallback, this),
          error: $.proxy(this.failureCallback, this)
        };
        spartaTransportUtility.subscribe(transportObj);
      }
    } catch (ex) {
      this.failureCallback();
    }
    return this.ps;
  }

  /**
   * Success callback function to be passed to transport utility
   * @param {object} data - response from service
   * @returns {void}
   */
  successCallback(data) {
    this.ps.resolve(data);
  }

  /**
   * Failure callback function to be passed to transport utility
   * @returns {void}
   */
  failureCallback() {
    let data = {
      error: 'service',
      ErrorMsg: 'Exception in record user experience service call'
    };
    this.ps.reject(data);
  }

  /**
   * Go to link
   * @param {object} $link - instance of link.
   * @returns {void}
   */
  goToLink(link) {
    let url = link.attr('href');
    let target = link.attr('target');
    if (typeof target === 'string' && target.length > 0) {
      window.open(url, target);
    } else {
      document.location.href = url;
    }
    return false;
  }

  /**
   * Handle link click
   * @param {object} event - instance of event.
   * @returns {void}
   */
  handleLinkClick(event) {
    let link = $(event.target).closest('a');
    this.link = link;
    let firstLink = this.data.qa.answer.length > 0 ? null : $('.title a').eq(0)[0];
    event.preventDefault();
    if (this.data.siteSearch.first > 0 || link[0] !== firstLink) {
      if (this.data && this.data.queryId) {
        let request = {
          answerId: link.data('id'),
          queryId: this.data.queryId,
          type: 'selectedAnswer'
        };
        this.invokeService(request);
      }
      setTimeout($.proxy(function () {
        this.goToLink(this.link);
      }, this), this.options.delay);
    } else {
      this.goToLink(this.link);
    }
    return false;
  }

  /**
   * Handle results updated
   * @param {object} data - response data.
   * @returns {void}
   */
  handleResultsUpdated(data) {
    if (data) {
      this.data = data;
      if (this.data.queryId) {
        let request = {
          queryId: this.data.queryId,
          type: 'searchedAgain'
        };
        this.invokeService(request);
      }
      setTimeout($.proxy(this.CoreMetricsReset, this), this.options.delay);
      /*if (this.options.registerPageView) {
        this.CoreMetricsLoad(request, response);
      }*/
    }
  }

  /**
   * Handle third party link click
   * @param {object} event - instance of event.
   * @returns {void}
   */
  handleThirdPartyClick(event) {
    var $clicked = $(event.target);
    this.CoreMetricsLinkClick($clicked);
  }

  /**
   * Register event handlers
   * @returns {void}
   */
  registerEventHandlers() {
    this.options.headerResultsContainer.find('.title a, .answer a').off('click.tracking').on('click.tracking', $.proxy(this.handleLinkClick, this));
    this.options.headerResultsContainer.find("a.spa-global-search-managed-top-result--link").off('click.tracking').on("click.tracking", $.proxy(this.handleLinkClick, this));
    this.options.headerResultsContainer.find('.track-me').off('click.tracking').on('click.tracking', $.proxy(this.handleThirdPartyClick, this));
    this.options.stageResultsContainer.find('.title a, .answer a').off('click.tracking').on('click.tracking', $.proxy(this.handleLinkClick, this));
    this.options.stageResultsContainer.find("a.spa-global-search-managed-top-result--link").off('click.tracking').on("click.tracking", $.proxy(this.handleLinkClick, this));
    this.options.stageResultsContainer.find('.track-me').off('click.tracking').on('click.tracking', $.proxy(this.handleThirdPartyClick, this));
  }

  /**
   * Method to reset coremetrics info
   * @returns void
   */
  CoreMetricsReset() {
    try {
      if (window.bactm && typeof window.bactm.rescanDOM === 'function') {
        window.bactm.rescanDOM();
      }
    } catch (error) {
      console.log("search tracking util : window.bactm.rescanDOM ", error);
    }
  }

  /**
   * Method to track link clicks
   * @param {object} $link - instance of link.
   * @returns void
   */
  CoreMetricsLinkClick($link) {
    if ($($link).parents('button').length > 0) {
      $link = $($link).parents('button');
    }
    let href = $link.attr('href');
    let name = $link.attr('name');
    let element = $link[0].tagName.toUpperCase();
    let type = $link.attr('type');
    if (!name) {
      name = $link.attr('data-bactmln');
    }
    switch (element) {
      case 'INPUT':
        href = element + (type ? ':' + type.toUpperCase() : '');
        break;
    }
    try {
      if (window.bactm && typeof window.bactm.manualLinkClick === 'function') {
        window.bactm.manualLinkClick(href, name);
      }
    } catch (error) {
      console.log("search tracking util : window.bactm.manualLinkClick ", error);
    }
  }
}

export { GlobalSearchTrackingUtility as default };
